// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html[driver-step="0"] .tutorial-theme {
    transform: translateY(10px);
    animation: fadeInPopover 500ms ease-out 150ms forwards;
}

html[tour-mode='pre-game'] .driver-fade .driver-overlay {
    animation: none;
}

@keyframes fadeInPopover {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.tutorial-theme h3:first-child {
    margin-top: 0;
}

.feedback-example {
    width: 250px;
}

.tutorial-theme * {
    font-family: var(--main-font) !important;
}

.tutorial-theme, .tutorial-theme button, .tutorial-theme .driver-popover-description, .tutorial-theme .driver-popover-description p, .tutorial-theme .driver-popover-description b, .tutorial-theme .driver-popover-title {
    background-color: var(--body-background-color);
    color: inherit;
    font-family: var(--main-font) !important;
}

.tutorial-theme h2 {
    margin-top: 0.5rem;
}

.driver-popover-footer button {
    text-shadow: none;
}

.driver-popover.tutorial-theme .driver-popover-arrow-side-left.driver-popover-arrow {
    border-left-color: var(--body-background-color);
  }
  
  .driver-popover.tutorial-theme .driver-popover-arrow-side-right.driver-popover-arrow {
    border-right-color: var(--body-background-color);
  }
  
  .driver-popover.tutorial-theme .driver-popover-arrow-side-top.driver-popover-arrow {
    border-top-color: var(--body-background-color);
  }
  
  .driver-popover.tutorial-theme .driver-popover-arrow-side-bottom.driver-popover-arrow {
    border-bottom-color: var(--body-background-color);

  }

  .driver-popover-footer button:hover, .driver-popover-footer button:focus {
    background-color: var(--button-hover-color);
  }

#driver-popover-description {
    font-size: 1.1rem;
}

.tutorial-theme button {
    font-size: 1.1rem;
    padding: 0.5rem;
}

.tutorial-theme button.driver-popover-close-btn {
    visibility: hidden;
}

.tutorial-theme header {
    font-size: 1.25rem;
    font-weight: 600;
}

.share-incentive-popover {
    text-align: center;
    padding: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/tutorial.css"],"names":[],"mappings":";AACA;IACI,2BAA2B;IAC3B,sDAAsD;AAC1D;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8CAA8C;IAC9C,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;EACjD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,iDAAiD;;EAEnD;;EAEA;IACE,2CAA2C;EAC7C;;AAEF;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":["\nhtml[driver-step=\"0\"] .tutorial-theme {\n    transform: translateY(10px);\n    animation: fadeInPopover 500ms ease-out 150ms forwards;\n}\n\nhtml[tour-mode='pre-game'] .driver-fade .driver-overlay {\n    animation: none;\n}\n\n@keyframes fadeInPopover {\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.tutorial-theme h3:first-child {\n    margin-top: 0;\n}\n\n.feedback-example {\n    width: 250px;\n}\n\n.tutorial-theme * {\n    font-family: var(--main-font) !important;\n}\n\n.tutorial-theme, .tutorial-theme button, .tutorial-theme .driver-popover-description, .tutorial-theme .driver-popover-description p, .tutorial-theme .driver-popover-description b, .tutorial-theme .driver-popover-title {\n    background-color: var(--body-background-color);\n    color: inherit;\n    font-family: var(--main-font) !important;\n}\n\n.tutorial-theme h2 {\n    margin-top: 0.5rem;\n}\n\n.driver-popover-footer button {\n    text-shadow: none;\n}\n\n.driver-popover.tutorial-theme .driver-popover-arrow-side-left.driver-popover-arrow {\n    border-left-color: var(--body-background-color);\n  }\n  \n  .driver-popover.tutorial-theme .driver-popover-arrow-side-right.driver-popover-arrow {\n    border-right-color: var(--body-background-color);\n  }\n  \n  .driver-popover.tutorial-theme .driver-popover-arrow-side-top.driver-popover-arrow {\n    border-top-color: var(--body-background-color);\n  }\n  \n  .driver-popover.tutorial-theme .driver-popover-arrow-side-bottom.driver-popover-arrow {\n    border-bottom-color: var(--body-background-color);\n\n  }\n\n  .driver-popover-footer button:hover, .driver-popover-footer button:focus {\n    background-color: var(--button-hover-color);\n  }\n\n#driver-popover-description {\n    font-size: 1.1rem;\n}\n\n.tutorial-theme button {\n    font-size: 1.1rem;\n    padding: 0.5rem;\n}\n\n.tutorial-theme button.driver-popover-close-btn {\n    visibility: hidden;\n}\n\n.tutorial-theme header {\n    font-size: 1.25rem;\n    font-weight: 600;\n}\n\n.share-incentive-popover {\n    text-align: center;\n    padding: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
